export type PhotoCategory = 'portrait' | 'fullbody'
export type FilterKey = 'all' | PhotoCategory

export type Photo = {
  id: string
  src: string
  category: PhotoCategory
}

export const filterKeys: FilterKey[] = ['all', 'portrait', 'fullbody']

const images = {
  headshot: 'https://cdn.magicpatterns.com/uploads/fywdmyYFGhrwgCMm4W1mBz/Fauve_1.jpg',
  headshotWhite:
    'https://cdn.magicpatterns.com/uploads/s8JsxQWjNdRfyq6UcvJRU3/WhatsApp_Image_2026-08-10_at_20.27.56.jpg',
  suitStanding:
    'https://cdn.magicpatterns.com/uploads/eUGzWpPAJwg9vBrTU5KJNw/WhatsApp_Image_2026-08-10_at_20.26.47.jpg',
  suitPortrait:
    'https://cdn.magicpatterns.com/uploads/bghRnU6XVh55tRNfcQcWcM/WhatsApp_Image_2026-08-10_at_20.26.48.jpg',
  denim:
    'https://cdn.magicpatterns.com/uploads/2DQuSwWpnYsDXKaNj9Cs8S/WhatsApp_Image_2026-08-10_at_20.27.56_(1).jpg',
  stool:
    'https://cdn.magicpatterns.com/uploads/hTZt7AisdKCNSVAvRw6C5Z/WhatsApp_Image_2026-08-10_at_20.28.58_(1).jpg',
  bodysuit:
    'https://cdn.magicpatterns.com/uploads/tFYjhoePKgpo1oxkLq9irM/WhatsApp_Image_2026-08-10_at_20.28.58.jpg',
}

export const photos: Photo[] = [
  { id: 'headshot', src: images.headshot, category: 'portrait' },
  { id: 'headshot-white', src: images.headshotWhite, category: 'portrait' },
  { id: 'suit-portrait', src: images.suitPortrait, category: 'portrait' },
  { id: 'bodysuit', src: images.bodysuit, category: 'portrait' },
  { id: 'suit-standing', src: images.suitStanding, category: 'fullbody' },
  { id: 'denim', src: images.denim, category: 'fullbody' },
  { id: 'stool', src: images.stool, category: 'fullbody' },
]

